import { User } from "lucide-react"
import { FC } from "react"
import { Link } from "react-router-dom"
import { useSigninCheck } from "../../hooks/use-firebase"
import { SubscriptionTypeEnum } from "../../lib/enums"
import { Popover, PopoverContent, PopoverTrigger } from "../ui"

type HeaderProps = {
	subscription?: SubscriptionTypeEnum
}

const Header: FC<HeaderProps> = ({ subscription }) => {
	const { data: signInResult } = useSigninCheck()

	return (
		<div className="fixed top-0 left-0 w-full bg-gradient-to-r from-sumoPrimary via-sumoAmber to-sumoOrange  shadow-medium z-50 border-b-4 border-sumoPrimary">
			<div className="px-4 py-3 flex items-center justify-between">
				<div className="flex items-center gap-3">
					<div className="text-2xl font-bold tracking-tight flex gap-2 items-center">
						<span className="text-sumoNavy">INVENTORY</span>
						<span className="text-white">SUMO</span>
					</div>
					{signInResult?.signedIn && subscription &&
						(subscription !== SubscriptionTypeEnum.Basic) &&
						<div className="px-3 py-1 rounded-full bg-sumoNavy text-sumoPrimary text-xs font-bold uppercase tracking-wide shadow-yellow">
							{subscription}
						</div>
					}
				</div>

				{signInResult?.signedIn ? (
					<Popover>
						<PopoverTrigger>
							<div className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-sumoNavy/10 dark:hover:bg-white/10 transition-all duration-200 cursor-pointer">
								<User width={20} height={20} className="text-sumoNavy dark:text-white" />
							</div>
						</PopoverTrigger>
						<PopoverContent className="w-48 animate-scale-in">
							<div className="flex flex-col gap-1">
								<Link
									to="/logout"
									className="px-4 py-2 text-sm font-medium rounded-md hover:bg-neutral100 dark:hover:bg-neutral700 transition-colors text-neutral900 dark:text-neutral100"
								>
									Logout
								</Link>
							</div>
						</PopoverContent>
					</Popover>
				) : (
					<Link
						to="/login"
						className="px-4 py-2 text-sm font-semibold rounded-md border-2 border-sumoNavy dark:border-sumoPrimary bg-sumoNavy dark:bg-sumoPrimary text-sumoPrimary dark:text-sumoNavy hover:bg-sumoNavy/90 dark:hover:bg-sumoAmber transition-all duration-200 shadow-yellow"
					>
						Login
					</Link>
				)}
			</div>
		</div>
	)
}

export default Header
